import React, { useEffect, useState } from "react";
import "../../stylesheet/Home.css";
import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined";
import ComputerIcon from "@mui/icons-material/Computer";
// import Tilt from "react-parallax-tilt";
import CardGiftcardOutlinedIcon from "@mui/icons-material/CardGiftcardOutlined";
// import Box from "@mui/material/Box";
// import TextField from "@mui/material/TextField";
import SellIcon from "@mui/icons-material/Sell";
import Nav from "../../components/Nav";
import Footer from "../../components/Footer";
import CheckCircleOutlineOutlinedIcon from "@mui/icons-material/CheckCircleOutlineOutlined";
// import CalculateIcon from "@mui/icons-material/Calculate";
import ShoppingBagOutlinedIcon from "@mui/icons-material/ShoppingBagOutlined";
// import AirplanemodeActiveOutlinedIcon from "@mui/icons-material/AirplanemodeActiveOutlined";
// import DirectionsBoatOutlinedIcon from "@mui/icons-material/DirectionsBoatOutlined";
// import WarehouseOutlinedIcon from "@mui/icons-material/WarehouseOutlined";
import LocalShippingOutlinedIcon from "@mui/icons-material/LocalShippingOutlined";
// import ArrowRightAltOutlinedIcon from "@mui/icons-material/ArrowRightAltOutlined";
import EngineeringOutlinedIcon from "@mui/icons-material/EngineeringOutlined";
// import ShoppingBagIcon from "@mui/icons-material/ShoppingBag";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import Fade from 'react-reveal/Fade';
import { Pagination, Autoplay } from "swiper/modules";
import CallMadeIcon from "@mui/icons-material/CallMade";
// import Calc from "../../components/Calc";
import {
  // Calculate,
  FlightTakeoff,
  Instagram,
  Star,
  StarBorder,
  StarHalf,
  Twitter,
} from "@mui/icons-material";
import { Link } from "react-router-dom";
// import PgTitle from "../../components/PgTitle";
import FacebookIcon from "@mui/icons-material/Facebook";
import { IconButton } from "@mui/material";
import PopAd from "../../components/PopAd";
import { fetchreq } from "../../Helper/fetch";


const Home = () => {
  const [photos, setPhotos] = useState([]);
  const loadlandingPhoto = async () => {
    const dt = await fetchreq("GET", "landingpagePhotos", {});
    dt ? setPhotos(JSON.parse(dt.result[0].Details)) : setPhotos([]);
    // console.log("hi",dt.result[0]?.Details);
  };
  const url = process.env.REACT_APP_URL;
  const temp = ["./imgs/sd1.png", "./imgs/sd2.png", "/home/home.png"];
  const [review,setReview]=useState(null);
  const getReview = async ()=>{
    const dt = await fetchreq("GET","Review",{});
    dt? setReview(dt.result): setReview([])
  }
  useEffect(() => {
    loadlandingPhoto();
    getReview();
  }, []);
  const [value, setValue] = useState(
    window.innerWidth < 900
      ? 1
      : window.innerWidth >= 900 && window.innerWidth <= 1300
      ? 2
      : 4
  );
  const handelsubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    // Iterate through form data and log each field's name and value
    const arr = [];
    formData.forEach((value, key) => {
      console.log(`${key}: ${value}`);
      arr.push(value);
    });
    // name: adgtafasf
    // email: ads@iau.o
    // subject: asjdkfjafjajf
    // message: 45487547578445
    const dt = await fetchreq("POST", "sendMail", {
      email: "connect.qubit@gmail.com",
      subject: arr[2],
      html: `<h3>Name: ${arr[0]} \n\n email: ${arr[1]} \n </h3><p>Message: ${arr[3]}</p>`,
    });
    if (dt) {
      alert("Submit Successfully...");
    }
  };
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  // Update the windowWidth state when the window is resized
  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  // Determine the src for the img element based on the windowWidth
  const imgSrc = windowWidth <= 600 ? "/imgs/hm-bg-2.jpg" : "/imgs/hm-bg.png";

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      let newValue;

      if (width < 900) {
        newValue = 1;
      } else if (width >= 900 && width <= 1300) {
        newValue = 2;
      } else {
        newValue = 4;
      }

      setValue(newValue);
    };

    // Listen for the window resize event
    window.addEventListener("resize", handleResize);

    // Clean up the event listener when the component unmounts
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);


  const [isVisible, setIsVisible] = useState(false);
  const [isVisible2, setIsVisible2] = useState(false);
  const [isVisible3, setIsVisible3] = useState(false);
  const [isVisible4, setIsVisible4] = useState(false);
 

  useEffect(() => {
    // Add a scroll event listener to check when the component is in the viewport
    const handleScroll = () => {
      
      const element2 = document.getElementById('scroll-fade2');
      const element3 = document.getElementById('scroll-fade3');
      const element4 = document.getElementById('scroll-fade4');
      const element5 = document.getElementById('scroll-fade5');
      const element6 = document.getElementById('scroll-fade6');
      const element7 = document.getElementById('scroll-fade7');
      const element8 = document.getElementById('scroll-fade8');
      const element9 = document.getElementById('scroll-fade9');
      const element10 = document.getElementById('scroll-fade10');
      const element11 = document.getElementById('scroll-fade11');
if( window.innerWidth > 1340) {

  if (element2) {
    const rect = element2.getBoundingClientRect();
    const isVisible2 = rect.top <= window.innerHeight;
    setIsVisible2(isVisible2);
    console.log(isVisible2);
  }
  if (element3) {
    const rect = element3.getBoundingClientRect();
    const isVisible3 = rect.y;
    setIsVisible3(isVisible3);
  } 
  if (element4) {
    const rect = element4.getBoundingClientRect();
    const isVisible4 = rect.y;
    setIsVisible4(isVisible4);
  }
  if (element5) {
    const rect = element4.getBoundingClientRect();
    const isVisible5 = rect.y;
    setIsVisible4(isVisible4);
  }
  if (element6) {
    const rect = element4.getBoundingClientRect();
    const isVisible6 = rect.y;
    setIsVisible4(isVisible4);
  }
  if (element7) {
    const rect = element4.getBoundingClientRect();
    const isVisible7 = rect.y;
    setIsVisible4(isVisible4);
  }
  if (element8) {
    const rect = element4.getBoundingClientRect();
    const isVisible8 = rect.y;
    setIsVisible4(isVisible4);
  }
} else {

  if (element2) {
    const rect = element2.getBoundingClientRect();
    const isVisible2 = window.innerHeight;
    window.removeEventListener('scroll', handleScroll);
    setIsVisible2(isVisible2);
  }
  if (element3) {
    const rect = element3.getBoundingClientRect();
    const isVisible3 =  window.innerHeight;
    window.removeEventListener('scroll', handleScroll);
    setIsVisible3(isVisible3);
  }
  if (element4) {
    const rect = element4.getBoundingClientRect();
    const isVisible4 =  window.innerHeight;
    window.removeEventListener('scroll', handleScroll);
    setIsVisible4(isVisible4);
  }
}
};

    // Attach the scroll event listener
    window.addEventListener('scroll', handleScroll);

    // Clean up the event listener when the component unmounts
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);



  return (
    <>
      <div id="Site">
        <header>
          <Nav />
        </header>
        <PopAd />
        <div id="homesec" className="hero-cont">
          <div class="swiper hmmm">
            <div class="swiper-wrapper">
              <div class="swiper-slide">
                
                    <video src="/video/intro.mp4" autoPlay muted></video>
                
              </div>
              <div class="swiper-slide">
                <img src={"/banner/banner.png"} alt="no"></img>
              </div>
              <div class="swiper-slide">
                <img src={"/banner/banner2.png"} alt="no"></img>
              </div>
            </div>
          </div>{" "}
        </div>
        {/* <SwiperSlide>
                <HomeSlide bgimg="./imgs/sd1.png" />
              </SwiperSlide>
              <SwiperSlide>
                <HomeSlide bgimg="./imgs/sd3.png" />
              </SwiperSlide>
              <SwiperSlide>
                <HomeSlide bgimg="./imgs/sd2.png" />
              </SwiperSlide> */}


      <div id="scroll-fade2">
        <Fade bottom when={isVisible2}>
        <div id="sec-section">
          <div id="sec-head">
            <div className="t-title" id="dg">
              HOW
              <span id="bul"> IT </span>
              WORKS
            </div>
          </div>
          <div id="steps">
            <div className="s-cd">
              {/* <div className="pin">
                <img src="./imgs/pin.png" alt="" />
              </div> */}
              <div id="sdsc-ol">
                {" "}
                <img
                  src="https://d2kh7o38xye1vj.cloudfront.net/wp-content/uploads/2023/07/Shipping-2-1.webp"
                  alt=""
                />
              </div>
              {/* <div className="st">RECEIVE WITHIN 7 / 8 WORKING DAYS</div> */}
              <div className="st"> International shipping</div>
              <div className="st-2">
                {" "}
                Simplify exports and expand your business to more than 220
                countries and territories
              </div>
              <div className="expl">
                Explore{" "}
                <span>
                  <CallMadeIcon />
                </span>{" "}
              </div>
            </div>
            <div className="s-cd">
              {/* <div className="pin">
               <div id='sdsc-ol'></div> <img src="./imgs/pin.png" alt="" />
              </div> */}
              <div id="sdsc-ol">
                {" "}
                <img
                  src="https://d2kh7o38xye1vj.cloudfront.net/wp-content/uploads/2023/08/sr-menu-1-1-64cb708d894d5.webp"
                  alt=""
                />
              </div>
              {/* <div className="st">SHOP FROM INDIAN SITES</div> */}
              <div className="st">Shop from indian sites</div>
              <div className="st-2">
                Lorem ipsum dolor sit amet, consectetur adipisicing elit.
                Cupiditate, quidem!{" "}
              </div>{" "}
              <div className="expl">
                Explore{" "}
                <span>
                  <CallMadeIcon />
                </span>{" "}
              </div>
            </div>
            <div className="s-cd">
              {/* <div className="pin">
               <div id='sdsc-ol'></div> <img src="./imgs/pin.png" alt="" />
              </div> */}
              <div id="sdsc-ol">
                {" "}
                <img
                  src="https://d2kh7o38xye1vj.cloudfront.net/wp-content/uploads/2023/07/shipping-rv-2.webp"
                  alt=""
                />
              </div>
              {/* <div className="st">SHIP PARCELS TO YOUR WAREHOUSE</div> */}
              <div className="st">B2B & B2C shipping service</div>
              <div className="st-2">
                Lorem ipsum dolor sit amet consectetur adipisicing elit.
                Obcaecati, nemo.{" "}
              </div>{" "}
              <div className="expl">
                Explore{" "}
                <span>
                  <CallMadeIcon />
                </span>{" "}
              </div>
            </div>{" "}
            <div className="s-cd">
              {/* <div className="pin">
               <div id='sdsc-ol'></div> <img src="./imgs/pin.png" alt="" />
              </div> */}
              <div id="sdsc-ol">
                <img src="./imgs/sdsc4.png" alt="" />
              </div>{" "}
              {/* <div className="st">SIGN-UP TO GET VIRTUAL ADDRESS</div> */}
              <div className="st">Get free indian virtual address</div>
              <div className="st-2">
                Lorem ipsum dolor sit amet, consectetur adipisicing elit.
                Cupiditate, quidem!{" "}
              </div>{" "}
              <div className="expl">
                Explore{" "}
                <span>
                  <CallMadeIcon />
                </span>{" "}
              </div>{" "}
            </div>
          </div>
          <br />
          <br />
          <br />
          <center>
            <Link to="/in-sites" className="btn btn-og">
              Explore More
            </Link>
          </center>
        </div>
</Fade>
</div>


        <div id="scroll-fade4">
        <Fade bottom when={isVisible3}>
        <div className="section-m">
          <div id="service-we-offer">
            <div className="ser-head">
              <center className="sh1">
                <h1 id="dg">
                  Services We
                  <span id="org" style={{ color: "var(--blue)" }}>
                    {" "}
                    Offer
                  </span>
                </h1>
                <img
                  className="service-img"
                  src="./imgs/sctr.png"
                  alt="no"
                ></img>
              </center>
            </div>
          </div>

          <div id="lnl">
            <div id="pop-ser">
              <div className="ps">
                <div className="ps-l">
                  <SellIcon />
                </div>
                <div className="ps-r">
                  <div className="st">Plans We Offer</div>
                  <div className="s-txt">
                    We offer a range of plans to suit your needs, from basic to
                    premium and business , ensuring affordability and
                    flexibility.
                  </div>
                  <div className="rm " id="org">
                    <Link to="/disp-plan" rel="noopener noreferrer">
                      View Plans
                    </Link>
                  </div>
                </div>
              </div>
              <div className="ps">
                <div className="ps-l">
                  <FlightTakeoff />
                </div>
                <div className="ps-r">
                  <div className="st wt">International Courier</div>
                  <div className="s-txt">
                    WE OFFER A HASSLE FREE, RELIABLE AND LOW-COST COURIER
                    SERVICE FROM INDIA INTERNATIONALLY.{" "}
                  </div>
                  <Link to="/coming-soon" rel="noopener noreferrer">
                    <div className="rm " id="org">
                      View More
                    </div>
                  </Link>
                </div>
              </div>
            </div>
            <div id="pop-ser" className="pop-2 pp2">
              <div className="ps">
                <div className="ps-l">
                  <ShoppingCartOutlinedIcon />
                </div>
                <div className="ps-r">
                  <div className="st">Indian Shop Cart</div>
                  <div className="s-txt">
                    SHOP FROM THE BEST OF INDIA’S BRANDS, AND GET THEM DELIVERED
                    FROM INDIA INTERNATIONALLY.
                  </div>
                  <Link to="/in-sites" rel="noopener noreferrer">
                    <div className="rm " id="org">
                      View Sites
                    </div>
                  </Link>
                </div>
              </div>
              <div className="ps">
                <div className="ps-l">
                  <CardGiftcardOutlinedIcon />
                  {/* <LocalShippingOutlinedIcon /> */}
                </div>
                <div className="ps-r">
                  <div className="st wt">Offer Coupons</div>
                  <div className="s-txt">
                    WE PROVIDE SEVERAL OFFER COUPONS. ALL YOU HAVE TO DO IS
                    BROWSE AND APPLY THE COUPON CODE OF YOUR CHOICE IN ORDER TO
                    REDEEM IT.{" "}
                  </div>
                  <div className="rm " id="org">
                    <Link to="/offers" rel="noopener noreferrer">
                      View Coupons
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
              </Fade>
              </div>

        <div id="scroll-fade5">
        <Fade bottom when={isVisible3}>
        <div className="t-title" style={{ marginBottom: "20px" }}>
              <span className="sites">
                Various
                <span id="bul" style={{padding: "0 15px"}}> Indian </span>
                Sites
              </span>
            </div>
        <section id="Site" className="bkl">
          <div id="indianshopcart" style={{ padding: "10vh 0px" }}>
            

            <div class="client-slider">
              <div class="client-slide-track">
                <div class="client-slide">
                  <img src="./comp/1.png" alt="" />
                </div>
                <div class="client-slide">
                  <img src="./comp/2.png" alt="" />
                </div>
                <div class="client-slide">
                  <img src="./comp/3.png" alt="" />
                </div>
                <div class="client-slide">
                  <img src="./comp/4.png" alt="" />
                </div>
                <div class="client-slide">
                  <img src="./comp/5.png" alt="" />
                </div>
                <div class="client-slide">
                  <img src="./comp/6.png" alt="" />
                </div>
                <div class="client-slide">
                  <img src="./comp/7.png" alt="" />
                </div>
                <div class="client-slide">
                  <img src="./comp/8.png" alt="" />
                </div>
                <div class="client-slide">
                  <img src="./comp/9.png" alt="" />
                </div>
                <div class="client-slide">
                  <img src="./comp/10.png" alt="" />
                </div>
                <div class="client-slide">
                  <img src="./comp/11.png" alt="" />
                </div>
                <div class="client-slide">
                  <img src="./comp/12.png" alt="" />
                </div>
                <div class="client-slide">
                  <img src="./comp/13.png" alt="" />
                </div>
                <div class="client-slide">
                  <img src="./comp/14.png" alt="" />
                </div>
                <div class="client-slide">
                  <img src="./comp/15.png" alt="" />
                </div>
                <div class="client-slide">
                  <img src="./comp/16.png" alt="" />
                </div>
              </div>
            </div>
            <div class="client-slider cl-cd-2">
              <div class="client-slide-track">
                <div class="client-slide">
                  <img src="./comp/1.png" alt="" />
                </div>
                <div class="client-slide">
                  <img src="./comp/2.png" alt="" />
                </div>
                <div class="client-slide">
                  <img src="./comp/3.png" alt="" />
                </div>
                <div class="client-slide">
                  <img src="./comp/4.png" alt="" />
                </div>
                <div class="client-slide">
                  <img src="./comp/5.png" alt="" />
                </div>
                <div class="client-slide">
                  <img src="./comp/6.png" alt="" />
                </div>
                <div class="client-slide">
                  <img src="./comp/7.png" alt="" />
                </div>
                <div class="client-slide">
                  <img src="./comp/8.png" alt="" />
                </div>
                <div class="client-slide">
                  <img src="./comp/9.png" alt="" />
                </div>
                <div class="client-slide">
                  <img src="./comp/10.png" alt="" />
                </div>
                <div class="client-slide">
                  <img src="./comp/11.png" alt="" />
                </div>
                <div class="client-slide">
                  <img src="./comp/12.png" alt="" />
                </div>
                <div class="client-slide">
                  <img src="./comp/13.png" alt="" />
                </div>
                <div class="client-slide">
                  <img src="./comp/14.png" alt="" />
                </div>
                <div class="client-slide">
                  <img src="./comp/15.png" alt="" />
                </div>
                <div class="client-slide">
                  <img src="./comp/16.png" alt="" />
                </div>
              </div>
            </div>

            <br />

            <center>
              <Link to="/in-sites" className="btn btn-w">
                Shop Now
              </Link>
            </center>
            <br />
          </div>
        </section>
        </Fade>
        </div>

        {/* <div className="festival">
         <Link to="/in-sites">
           <img src="/banner/banner4.png" alt="no"></img>
         </Link>
       </div> */}

<div id="scroll-fade3">
        <Fade bottom when={isVisible3}>
        <div style={{marginTop: "4rem"}} className="ser-head">
            <center className="sh1">
              <h1 id="dg">
                <span>Explore Our Business</span>
                <span id="org" style={{ color: "var(--blue)" }}>
                  {" "}
                  Services
                </span>
              </h1>
            </center>
          </div>
        <section id="service" className="ser-sec-2">
          <div className="ser-cards">
            <div className="sc">
              <span>
                <div id="org">
                  <EngineeringOutlinedIcon />
                </div>
                <div className="t-title">Business Plan</div>
              </span>
              <p>
                Sea cargo dispatches in excess of 5,500 holders per day to ports
                all around the globe, making us a top forwarder.
              </p>
              <ul>
                <li>Less-than-container Load</li>
                <li>Full Container Load</li>
                <li>Inter-modal Solutions</li>
              </ul>
              <a href="/coming-soon" className="btn btn-db">
                {" "}
                Comming Soon
              </a>
            </div>

            <div className="sc">
              <span>
                <div id="org">
                  <ComputerIcon />
                </div>
                <div className="t-title">Assisted Purchase</div>
              </span>
              <p>
                Sea cargo dispatches in excess of 5,500 holders per day to ports
                all around the globe, making us a top forwarder.
              </p>
              <ul>
                <li>Less-than-container Load</li>
                <li>Full Container Load</li>
                <li>Inter-modal Solutions</li>
              </ul>
              <Link to="/assisted-purchase" className="btn btn-db">
                {" "}
                Assisted Purchase
              </Link>
            </div>
            
        
            <div className="sc">
              <span>
                <div id="org">
                  <EngineeringOutlinedIcon />
                </div>
                <div className="t-title">White Labelling</div>
              </span>
              <p>
                Sea cargo dispatches in excess of 5,500 holders per day to ports
                all around the globe, making us a top forwarder.
              </p>
              <ul>
                <li>Less-than-container Load</li>
                <li>Full Container Load</li>
                <li>Inter-modal Solutions</li>
              </ul>
              <Link to="/white-labeling" className="btn btn-db">
                {" "}
                White Labeling
              </Link>
            </div>

            <div className="sc">
              <span>
                <div id="org">
                  <ComputerIcon />
                </div>
                <div className="t-title">Wholesaler Plan</div>
              </span>
              <p>
                Sea cargo dispatches in excess of 5,500 holders per day to ports
                all around the globe, making us a top forwarder.
              </p>
              <ul>
                <li>Less-than-container Load</li>
                <li>Full Container Load</li>
                <li>Inter-modal Solutions</li>
              </ul>
              <a href="/wholesaler" className="btn btn-db">
                {" "}
                Wholesaler
              </a>
            </div>
          </div>
          <br />
          <br />
        </section>
        </Fade>
        </div>



        {/* <div className="calculator">
         <Link to="/calc">
           <img src="/banner/cal.png" height={300} alt="no"></img>
         </Link>
       </div> */}
        <br />
        <div id="scroll-fade8">
        <Fade bottom when={isVisible3}>
        <section id="cal">
          <div className="cal-head">
            <div className="t-title" id="dg">
              Shipping Rate Calculator{" "}
            </div>
            <Link to="/calc" rel="noopener noreferrer">
              <div className="btn btn-o">Calculate Now</div>
            </Link>
          </div>
        </section>
        </Fade>
        </div>

        <div id="scroll-fade9">
        <Fade bottom when={isVisible3}>
        <div id="pl-kd-sec">
          <div className="kd-l">
            <h2>our plans</h2>
            <h1>every great brand is like a great story</h1>
            <p>
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Commodi
              ratione perspiciatis repellendus totam reiciendis qui in ullam a
              corrupti. Architecto quam, aliquam neque obcaecati ipsum sit
              aperiam ex tenetur perferendis.
            </p>
            <Link to="/disp-plan">
              {" "}
              <div className="btn btn-o">Free Trial</div>
            </Link>
          </div>
          <div className="kd-r">
            <div className="kd-pl">
              <b>Half yearly</b>
              <big>₹2499</big>
              <div className="futrsss">
                <span>
                  {" "}
                  <CheckCircleOutlineOutlinedIcon id="ck-cr" /> consolidation
                </span>
                <span>
                  {" "}
                  <CheckCircleOutlineOutlinedIcon id="ck-cr" /> storage - 30
                  days
                </span>
                <span>
                  {" "}
                  <CheckCircleOutlineOutlinedIcon id="ck-cr" /> photos - 3
                </span>
                <span>
                  {" "}
                  <CheckCircleOutlineOutlinedIcon id="ck-cr" /> unlimited
                  address
                </span>
                {/* <span> <CheckCircleOutlineOutlinedIcon id="ck-cr" /> </span> */}
              </div>
              <Link to="/disp-plan">
                {" "}
                <div className="btn btn-o">buy now</div>
              </Link>
            </div>
            <div className="kd-pl">
              <b>yearly</b>
              <big>₹4499</big>
              <div className="futrsss">
                <span>
                  {" "}
                  <CheckCircleOutlineOutlinedIcon id="ck-cr" /> photos - 3
                </span>
                <span>
                  {" "}
                  <CheckCircleOutlineOutlinedIcon id="ck-cr" /> consolidation
                </span>
                <span>
                  {" "}
                  <CheckCircleOutlineOutlinedIcon id="ck-cr" /> virtual address
                </span>
                <span>
                  {" "}
                  <CheckCircleOutlineOutlinedIcon id="ck-cr" /> pickup - free
                </span>
                <span>
                  {" "}
                  <CheckCircleOutlineOutlinedIcon id="ck-cr" /> free return
                </span>
                <span>
                  {" "}
                  <CheckCircleOutlineOutlinedIcon id="ck-cr" /> real time
                  tracking
                </span>
                <span>
                  {" "}
                  <CheckCircleOutlineOutlinedIcon id="ck-cr" /> and many more{" "}
                </span>
              </div>
              <Link to="/disp-plan">
                {" "}
                <div className="btn btn-o">buy now</div>
              </Link>
            </div>
          </div>
        </div>
       </Fade>
       </div>


       <div id="scroll-fade6" style={{marginBottom: "6rem"}}>
        <Fade bottom when={isVisible3}>
        <div id="fest-offer">
          <div className="pp">
            <div className=" ps-fo">
              <div className="ps-l">
                <ShoppingCartOutlinedIcon />
                <div className="t-title">View Our Offers</div>
              </div>
              <div className="ps-r">
                <Link to="/offers">
                  <div className="btn btn-o">View Offers</div>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </Fade>
      </div>

       <div id="scroll-fade10">
        <Fade bottom when={isVisible3}>
          <div id="feed-l">
            <center className="fd-title" id="dg">
              What People Say About Our <span style={{color: "var(--blue)"}}>Company</span>
            </center>
          </div>
        <section id="feed">
          <div id="feed-r" style={{paddingTop: "3rem"}}>
            <Swiper
              id="fd-scr"
              // spaceBetween={120}
              slidesPerView={value}
              autoplay={{
                delay: 3000,
                disableOnInteraction: false,
              }}
              loop={true}
              modules={[Autoplay]}
              className="mySwiper"
              // loop={true}
            >
               <SwiperSlide>
               <div className="fd-cd">
                 <div className="feed-info">
                   <div id="hd-fd">
                     <div style={{borderBottom: "1px solid black",width: 'fit-content', margin: 'auto'}}>
                       Rishav Jaiswal
                     </div>
                     <div className="sitara">
                       <StarBorder />
                       <StarHalf />
                       <Star />
                       <Star />
                       <Star />
                     </div>{" "}
                     <div className="msg-title">"Great Work"</div>
                     <div id="org">CLIENT OF COMPANY</div>
                     <div className="msg-desc">
                       I work in project management and joined Unicoach because
                       I get great courses for less. The instructors are
                       fantastic, interesting, and helpful. I plan to use for a
                       long time!
                     </div>
                   </div>{" "}
                 </div>{" "}
                 
               </div>
             </SwiperSlide>
             <SwiperSlide>
               <div className="fd-cd">
                 <div className="feed-info">
                   <div id="hd-fd">
                     {" "}
                     <div style={{borderBottom: "1px solid black",width: 'fit-content', margin: 'auto'}}>
                       Saurav Singh
                     </div>
                     <div className="sitara">
                       <StarBorder />
                       <StarHalf />
                       <Star />
                       <Star />
                       <Star />
                     </div>{" "}
                     <div className="msg-title">"Great Work"</div>
                     <div id="org">CLIENT OF COMPANY</div>
                     <div className="msg-desc">
                       I work in project management and joined Unicoach because
                       I get great courses for less. The instructors are
                       fantastic, interesting, and helpful. I plan to use for a
                       long time!
                     </div>
                   </div>{" "}
                 </div>{" "}
                
               </div>
             </SwiperSlide>
             <SwiperSlide>
               <div className="fd-cd">
                 <div className="feed-info">
                   <div id="hd-fd">
                     <div style={{borderBottom: "1px solid black",width: 'fit-content', margin: 'auto'}}>
                       Aman Kumar
                     </div>
                     <div className="sitara">
                       <StarBorder />
                       <StarHalf />
                       <Star />
                       <Star />
                       <Star />
                     </div>{" "}
                     <div className="msg-title">"Great Work"</div>
                     <div id="org">CLIENT OF COMPANY</div>
                     <div className="msg-desc">
                       I work in project management and joined Unicoach because
                       I get great courses for less. The instructors are
                       fantastic, interesting, and helpful. I plan to use for a
                       long time!
                     </div>
                   </div>
                 </div>{" "}
                 
               </div>
             </SwiperSlide>
             <SwiperSlide>
               <div className="fd-cd">
                 <div className="feed-info">
                   <div id="hd-fd">
                     {" "}
                     <div style={{borderBottom: "1px solid black",width: 'fit-content', margin: 'auto'}}>
                       Lilly Singh
                     </div>
                     <div className="sitara">
                       <StarBorder />
                       <StarHalf />
                       <Star />
                       <Star />
                       <Star />
                     </div>{" "}
                     <div className="msg-title">"Great Work"</div>
                     <div id="org">CLIENT OF COMPANY</div>
                     <div className="msg-desc">
                       I work in project management and joined Unicoach because
                       I get great courses for less. The instructors are
                       fantastic, interesting, and helpful. I plan to use for a
                       long time!
                     </div>
                   </div>{" "}
                 </div>{" "}
                 
               </div>
             </SwiperSlide>
             <SwiperSlide>
               <div className="fd-cd">
                 <div className="feed-info">
                   <div id="hd-fd">
                     {" "}
                     <div style={{borderBottom: "1px solid black",width: 'fit-content', margin: 'auto'}}>
                       Happy Singh
                     </div>
                     <div className="sitara">
                       <StarBorder />
                       <StarHalf />
                       <Star />
                       <Star />
                       <Star />
                     </div>
                     <div className="msg-title">"Great Work"</div>
                     <div id="org">CLIENT OF COMPANY</div>
                     <div className="msg-desc">
                       I work in project management and joined Unicoach because
                       I get great courses for less. The instructors are
                       fantastic, interesting, and helpful. I plan to use for a
                       long time!
                     </div>
                   </div>{" "}
                 </div>{" "}
                
               </div>
             </SwiperSlide>
             <SwiperSlide>
               <div className="fd-cd">
                 <div className="feed-info">
                   <div id="hd-fd">
                     {" "}
                     <div style={{borderBottom: "1px solid black",width: 'fit-content', margin: 'auto'}}>
                       Guldeep
                     </div>
                     <div className="sitara">
                       <StarBorder />
                       <StarHalf />
                       <Star />
                       <Star />
                       <Star />
                     </div>
                     <div className="msg-title">"Great Work"</div>
                     <div id="org">CLIENT OF COMPANY</div>
                     <div className="msg-desc">
                       I work in project management and joined Unicoach because
                       I get great courses for less. The instructors are
                       fantastic, interesting, and helpful. I plan to use for a
                       long time!
                     </div>
                   </div>{" "}
                 </div>{" "}
                 
               </div>
             </SwiperSlide>
             <SwiperSlide>
               <div className="fd-cd">
                 <div className="feed-info">
                   <div id="hd-fd">
                     {" "}
                     <div style={{borderBottom: "1px solid black",width: 'fit-content', margin: 'auto'}}>
                       Sanaya
                     </div>
                     <div className="sitara">
                       <StarBorder />
                       <StarHalf />
                       <Star />
                       <Star />
                       <Star />
                     </div>
                     <div className="msg-title">"Great Work"</div>
                     <div id="org">CLIENT OF COMPANY</div>
                     <div className="msg-desc">
                       I work in project management and joined Unicoach because
                       I get great courses for less. The instructors are
                       fantastic, interesting, and helpful. I plan to use for a
                       long time!
                     </div>
                     
                   </div>{" "}
                 </div>{" "}
                 
               </div>
             </SwiperSlide>



                      {/* <div className="feed-info">
                        <div id="hd-fd">
                          <div id="blue" className="btn btn-b">
                            {r.Name}
                          </div>
                          {/* <div className="msg-title">"Great Work"</div> */}
                          {/* <div id="org">CLIENT OF COMPANY</div>
                          <div className="msg-desc">{r.Review}</div>
                          <div className="sitara">
                            {Array(r.Star)
                              .fill(null)
                              .map((a) => {
                                return <Star />;
                              })}
                          </div>{" "}
                        </div>{" "}
                      </div> */} 
                      
                  
            </Swiper>
          </div>
        </section>
        </Fade>
        </div>


        <div id="scroll-fade11">
        <Fade bottom when={isVisible3}>
          <div className="fr-title">
            <div className="t-titlee">Recognition </div>
          </div>
        <section id="fr-in">
          <div className="reco">
            <div>
              <img src="./ftrd/1.png" alt="" />
            </div>
            <div class=" ">
              <img src="./ftrd/3.png" alt="" />
            </div>
            <div class=" ">
              <img src="./ftrd/4.png" alt="" />
            </div>

            <div class="">
              <img src="./ftrd/5.png" alt="" />
            </div>
            <div class=" ">
              <img src="./ftrd/6.png" alt="" />
            </div>
          </div>
        </section>
        </Fade>
      </div>
      </div>

      {/* <div id="contact-sec">
        <div id="con-head">
          <h1 id="dg">YOUR INDIAN SHOP</h1>
          <div className="s-media">
            <IconButton>
              <FacebookIcon />
            </IconButton>
            <IconButton>
              <YouTubeIcon />
            </IconButton>
            <IconButton>
              <Twitter />
            </IconButton>
            <IconButton>
              <Instagram />
            </IconButton>
          </div>{" "}
        </div>
        <div className="con-body">
          <div className="con-l">
            <h1 id="dg">Reach Us </h1>
            <i>Please fill out the form below to send us an email.</i>
            <p>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
              enim ad minim veniam, quis nostrud exercitation ullamco laboris
              nisi ut aliquip ex ea commodo consequat.
            </p>
            <h2 id="dg">
            </h2>{" "}
            <div
              className="con-ftr"
              // style={{ justifySelf: "flex-end !important" }}
            >
              <Link to="/signUp">
                <div className="btn btn-db">SIGN UP</div>
              </Link>
              <Link to="/offers">
                <div className="btn btn-db">OFFERS</div>
              </Link>
              <Link to="/dis-plan">
                <div className="btn btn-db">PLANS</div>
              </Link>
            </div>
          </div>
          <form className="col-r" onSubmit={handelsubmit}>
            <input
              required
              name="name"
              minLength={4}
              maxLength={50}
              type="text"
              className="soneri"
              placeholder="NAME"
            />
            <input
              required
              name="email"
              minLength={4}
              maxLength={50}
              type="email"
              placeholder="E-mail"
            />
            <input
              required
              name="subject"
              minLength={4}
              maxLength={30}
              type="text"
              className="soneri"
              placeholder="SUBJECT"
            />
            <textarea
              minLength={10}
              maxLength={500}
              required
              name="message"
              placeholder="MESSAGE"
              id=""
              cols="30"
              rows="10"
            ></textarea>
            <button type="submit" className="btn btn-gd">
              Submit
            </button>
          </form>
        </div>
      </div> */}
      <Footer />
    </>
  );
};

export default Home;
